export default class {
    constructor (name, config = {}) {
        if (name === undefined || typeof name !== 'string') {
            wealthify.error.throwError('PropType class', `name passed as ${name} but must be of type string`);
        }

        if (config?.validator !== undefined && !(config.validator instanceof wealthify.PropValidator)) {
            wealthify.error.throwError('PropType class', `${name} validator must be an instance of PropValidator class`);
        }

        if (config?.formatter !== undefined && !wealthify.type.function.isFunction(config.formatter)) {
            wealthify.error.throwError('PropType class', `${name} formatter must be of type function`);
        }

        if (config?.isComplex !== undefined && !wealthify.type.boolean.isBoolean(config.isComplex)) {
            wealthify.error.throwError('PropType class', `${name} isComplex must be of type boolean`);
        }

        this._name = name;
        this._validator = config?.validator;
        this._formatter = config?.formatter;
        this._isComplex = config?.isComplex || false;
    }

    get name () {
        return this._name;
    }

    get validator () {
        return this._validator;
    }

    get formatter () {
        return this._formatter;
    }

    get isComplex () {
        return this._isComplex;
    }

    format (value) {
        const hasFormatterAndValueDefined = this._formatter !== undefined && value !== undefined;

        if (hasFormatterAndValueDefined) {
            return this._formatter(value);
        }

        return value;
    }

}
